/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIEditor } from './APIEditor';
import {
    APIEditorFromJSON,
    APIEditorFromJSONTyped,
    APIEditorToJSON,
} from './APIEditor';

/**
 * 
 * @export
 * @interface APIOfferSearchResult
 */
export interface APIOfferSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIOfferSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIOfferSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIOfferSearchResult
     */
    remarks?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIOfferSearchResult
     */
    prices?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof APIOfferSearchResult
     */
    status?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIOfferSearchResult
     */
    statusDisplay?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIOfferSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIOfferSearchResult
     */
    lastModifiedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIOfferSearchResult
     */
    requestId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIOfferSearchResult
     */
    requestCertificate?: string;
    /**
     * 
     * @type {string}
     * @memberof APIOfferSearchResult
     */
    requestNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof APIOfferSearchResult
     */
    article?: string;
    /**
     * 
     * @type {string}
     * @memberof APIOfferSearchResult
     */
    articleNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof APIOfferSearchResult
     */
    articleName?: string;
    /**
     * 
     * @type {number}
     * @memberof APIOfferSearchResult
     */
    editorCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIOfferSearchResult
     */
    editorNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIOfferSearchResult
     */
    editorIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIOfferSearchResult
     */
    editorEmails?: Array<string>;
    /**
     * 
     * @type {Array<APIEditor>}
     * @memberof APIOfferSearchResult
     */
    editors?: Array<APIEditor>;
    /**
     * 
     * @type {string}
     * @memberof APIOfferSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APIOfferSearchResult interface.
 */
export function instanceOfAPIOfferSearchResult(value: object): value is APIOfferSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIOfferSearchResultFromJSON(json: any): APIOfferSearchResult {
    return APIOfferSearchResultFromJSONTyped(json, false);
}

export function APIOfferSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOfferSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'prices': json['prices'] == null ? undefined : json['prices'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusDisplay': json['status_display'] == null ? undefined : json['status_display'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'lastModifiedAt': json['last_modified_at'] == null ? undefined : (new Date(json['last_modified_at'])),
        'requestId': json['request_id'] == null ? undefined : json['request_id'],
        'requestCertificate': json['request_certificate'] == null ? undefined : json['request_certificate'],
        'requestNumber': json['request_number'] == null ? undefined : json['request_number'],
        'article': json['article'] == null ? undefined : json['article'],
        'articleNumber': json['article_number'] == null ? undefined : json['article_number'],
        'articleName': json['article_name'] == null ? undefined : json['article_name'],
        'editorCount': json['editor_count'] == null ? undefined : json['editor_count'],
        'editorNames': json['editor_names'] == null ? undefined : json['editor_names'],
        'editorIds': json['editor_ids'] == null ? undefined : json['editor_ids'],
        'editorEmails': json['editor_emails'] == null ? undefined : json['editor_emails'],
        'editors': json['editors'] == null ? undefined : ((json['editors'] as Array<any>).map(APIEditorFromJSON)),
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APIOfferSearchResultToJSON(value?: APIOfferSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'remarks': value['remarks'],
        'prices': value['prices'],
        'status': value['status'],
        'status_display': value['statusDisplay'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'last_modified_at': value['lastModifiedAt'] == null ? undefined : ((value['lastModifiedAt'] as any).toISOString()),
        'request_id': value['requestId'],
        'request_certificate': value['requestCertificate'],
        'request_number': value['requestNumber'],
        'article': value['article'],
        'article_number': value['articleNumber'],
        'article_name': value['articleName'],
        'editor_count': value['editorCount'],
        'editor_names': value['editorNames'],
        'editor_ids': value['editorIds'],
        'editor_emails': value['editorEmails'],
        'editors': value['editors'] == null ? undefined : ((value['editors'] as Array<any>).map(APIEditorToJSON)),
        'root_account_id': value['rootAccountId'],
    };
}

